import { auditItemHelpers } from '@internal-audit/domain/graphql-types';
import type { GraphQLAuditItem } from '@internal-audit/domain/graphql-types';
import { useCallback } from 'react';

/**
 * Custom hook providing helper functions for audit decision data extraction
 * Reduces complexity in the main AuditDecisionPanel component
 */
export function useAuditDecisionHelpers() {
  const getClassificationResults = useCallback((item: GraphQLAuditItem | null) => {
    if (!item?.contentSnapshot?.classificationResults) return [];

    return item.contentSnapshot.classificationResults.map(result => ({ name: result.name, severity: result.severity }));
  }, []);

  const getTranscription = useCallback((item: GraphQLAuditItem | null) => item?.contentSnapshot?.transcription || '', []);

  const getOcrText = useCallback((item: GraphQLAuditItem | null) => item?.contentSnapshot?.transcription || '', []);

  const getDetectedLanguage = useCallback((item: GraphQLAuditItem | null) => (item ? auditItemHelpers.getContentLanguage(item) : 'UNKNOWN'), []);

  const calculatePolicyCorrectness = useCallback(
    (triggeredAssessments: Array<{ isCorrect: boolean | null }>, nonTriggeredAssessments: Array<{ isCorrect: boolean | null }>): boolean | null => {
      const allAssessments = [...triggeredAssessments, ...nonTriggeredAssessments];
      const validAssessments = allAssessments.filter(a => a.isCorrect !== null);

      if (validAssessments.length === 0) return null;

      return validAssessments.every(a => a.isCorrect === true);
    },
    []
  );

  return {
    getClassificationResults,
    getTranscription,
    getOcrText,
    getDetectedLanguage,
    calculatePolicyCorrectness,
  };
}
